import { useSession } from '@/entities/session';
import { Item } from '@filament/common-react';
import { Avatar } from '@filament/react/avatar';
import { Button } from '@filament/react/button';
import { LogOut } from '@filament/react/icons/log-out';
import { PhilipsLogo } from '@filament/react/icons/philips-logo';
import { SidebarLeft } from '@filament/react/icons/sidebar-left';
import { FlexBox } from '@filament/react/layout';
import { MenuButton } from '@filament/react/menu-button';
import { H1, Text } from '@filament/react/text';
import { TopBar, TopBarTitle, TopBarUserInfo, } from '@filament/react/top-bar';
import { type Key } from '@filament/react/types';
import * as styles from './TopNavBar.css';
import { OrganizationSwitcher } from '@/features/organizations/switch';
import { PROJECT_NAME } from '@/shared/config';

type UserInfoProps = {
    username: string | undefined;
    workspaceName: string | undefined
}

const UserInfoComponent = ({ username, workspaceName }: UserInfoProps) => {
    return (
        <FlexBox flex={1} flexDirection='column'>
            <Text weight='bold'>{username}</Text>
            <Text variant='body-s' alignSelf='end'>{workspaceName}</Text>
        </FlexBox>
    )
}

type TopNavBarProps = {
    onSidebarToggle: () => void
}

export const TopNavBar = ({ onSidebarToggle }: TopNavBarProps) => {
    const { user, logout, currentOrganization } = useSession();
    const handleUserProfileAction = (action: Key) => {
        if (action === "logout") {
            logout();
        }
    };

    return (
        <TopBar className={styles.navigation} >
            <Button variant="quiet" isIconOnly onPress={onSidebarToggle}>
                <SidebarLeft />
            </Button>

            <TopBarTitle>
                <PhilipsLogo />
                <H1>{PROJECT_NAME}</H1>
            </TopBarTitle>

            <TopBarUserInfo flex={1}>

                <Avatar variant="primary" size={32}>
                    DA
                </Avatar>

                <MenuButton
                    className={styles.noHoverItem}
                    aria-label="settings"
                    variant="quiet"
                    shape="square"
                    placement="bottom end"
                    autoClose={false}
                    style={{ padding: 0 }}
                    data-testid="setting_menu_testId"
                    onAction={handleUserProfileAction}
                    buttonContent={(
                        <UserInfoComponent
                            username={user?.username}
                            workspaceName={currentOrganization.name}
                        />)}
                >
                    <Item key="organization_selector" textValue='organizations'>
                        <OrganizationSwitcher key="org-switcher"  />
                    </Item>

                    <Item data-testid="logout_menuitem_testId"
                        textValue="logout"
                        key="logout">
                        <LogOut /> Logout
                    </Item>
                </MenuButton>
            </TopBarUserInfo>
        </TopBar >
    );
};
